import React, { Component, PropTypes } from 'react';
import {reduxForm, resetForm} from "redux-form";
import {GetInterfaceLang, PaginationSentence, GetOneLanguage, getSituationSelect, getNotificationSelect, getSentence, GetOneLearningLanguage, getDetailSentense, GetChatPerson, addSentence, addNotification, getNotification, addTranslationSentense, updateNotification, updateSentence, updateTranslationSentense} from '../../actions/index';
import {Link} from 'react-router';
import _ from 'lodash';

let position_sentence = '';
let next = false;

class AddWord  extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props) {
        super(props);
        let that = this;
        this.state = {
            file: '',
            study_type: 'select',
            rendered: true,
            id_sentence: true,
            person: false
        };
        this.chooseFunc = this.chooseFunc.bind(this);
        this.renderTranslate = this.renderTranslate.bind(this);
        this.renderPeople = this.renderPeople.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.addWordSelect = this.addWordSelect.bind(this);
        this.save = this.save.bind(this);
        this.SubmitForm = this.SubmitForm.bind(this);
        this.select = this.select.bind(this);
        this.uploadState = this.uploadState.bind(this);
        this.positionValidate = this.positionValidate.bind(this);
        $('body').on('click', '#missed_words span.selected, #hint_block span.selected', function (e) {
            if ($('#missed_words, #hint_block').parent().hasClass('has-erorr')) {
                $('#missed_words, #hint_block').parent().removeClass('has-erorr')
            }
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            } else {
                $(this).addClass('active');
            }
            // $(this).toggleClass('active');
            that.props.fields.missed_words.onChange($('#missed_words').html());
            that.props.fields.hint.onChange($('#hint_block').html());
        });
    }

    componentWillMount() {
        $('input').val('');
        let token = localStorage.getItem('id_token_admin');
        this.props.GetOneLearningLanguage(this.props.params.id, token);
        this.props.GetInterfaceLang(token);
        this.props.GetChatPerson(token);
        this.props.getSituationSelect(token, this.props.params.id, this.props.params.id_sentence);
        this.props.getNotificationSelect(token, this.props.params.id, this.props.params.id_sentence);
        if (this.props.params.id_before) {
            position_sentence = this.props.params.id_before;
        } else {
            position_sentence = '';
        }
        if (this.props.params.id_sentence) {
            this.props.getDetailSentense(this.props.params.id_sentence, token, this.props.params.id).then((response) => {
                let page = response.payload.data.page;
                this.props.PaginationSentence(token, page, this.props.params.id);
                if (response.payload.data.notification) {
                    this.props.getNotification(token, response.payload.data.notification);
                }
            });
        }
        if (this.props.params.id_sentence) {
            this.setState({
                sentence: true
            })
        }
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
        $('#study_type').selectpicker();
    }

    componentDidUpdate() {
        $('#study_type').selectpicker('refresh');
    }

    componentWillUnmount() {
        this.props.lang.sentense_detail = {};
        this.props.lang.notofication_detail = {};
        this.props.lang.sentense = {};
        $('body').off('click', '#missed_words span.selected, #hint_block span.selected');
        this.props.resetForm();
        this.setState({
            person: false
        });
        // $('#missed_words span.selected, #hint_block span.selected').off('click').on('click');
    }

    edit(e) {
        let block = $(e.target).data('id')
        $('#' + block + ' .idetBlock').summernote({
            lang: "ru-RU",
            height: 150,
            dialogsInBody: true,
            toolbar: [
                ["font", ["bold", "underline", "clear"]],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ["para", ["ul", "ol", "paragraph"]],
                ["table", ["table"]],
                ["insert", ["link", "picture", "video"]],
                ["view", ["fullscreen", "codeview"]]
            ]
        });
        $('#' + block + ' .btn-primary').show();
    };

    save(e) {
        let block = $(e.target).data('id')
        let makrup = $('#' + block + ' .idetBlock').summernote('code');
        $('#' + block + ' .idetBlock').summernote('destroy');
        $('#' + block + ' .btn-primary').hide();
        let name = $(e.target).data('name');
        this.props.fields[name].onChange(makrup);
        $('#' + block + ' .idetBlock').parent().removeClass('has-error');
    };

    chooseFunc(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.fields[e.target.name].onChange(e.target.value);
        if (e.target.name == 'missed_words') {
            $('#missed_words').closest('.col-md-4').removeClass('has-error')
        }
        if (e.target.name == 'hint') {
            $('#hint_block').closest('.col-md-4').removeClass('has-error')
        }
        setTimeout(() => {
            $('.selectpicker').selectpicker();
        }, 500)
    }

    handleChange(e) {
        let obj = e.target.files[0];
        this.props.fields[e.target.name].onChange(obj);

        this.setState({
            [e.target.name]: obj.name
        });
    }

    addWordSelect(e) {
        this.props.fields[e.target.name].onChange(e.target.value);
        $('#missed_words, #hint_block').text(e.target.value);
        // replace(/\b([\w'-]+)\b/g, '<span class="selected">$1</span>');
        let str = $('#missed_words, #hint_block').text().replace(/(([\wа-яА-ЯЁёҤҥӦӧӰӱ\xC0-\u0192’´'-])+)/g, '<span class="selected">$1</span>');
        let str2 = str.replace(/([\,\.\!\:\“\„\‘\?\¡\¿]| - )/g, '<span class="no_selected">$1</span>');
        $('#missed_words, #hint_block').html(str2);
    }

    removeClass(e) {
        $('#' + e.target.name).closest('.sentences').removeClass('has-error')
    }

    editTranslation(id) {
        if (this.props.params.id_sentence) {
            let item = _.findWhere(this.props.lang.sentense_detail.translations, {blang: id});
            if (_.findWhere(this.props.lang.sentense_detail.translations, {blang: id})) {
                return (
                    <div className="col-md-4" key={item.id} id={item.id}>
                        <textarea className="form-control" name={item.id} defaultValue={item.phrase}
                                  onChange={this.removeClass}/>
                    </div>
                )
            }
            else {
                return (
                    <div className="col-md-4" id={id}>
                        <textarea className="form-control" name={id} onChange={this.removeClass}/>
                    </div>
                )
            }
        } else {
            return (
                <div className="col-md-4" id={id}>
                    <textarea className="form-control" name={id} onChange={this.removeClass}/>
                </div>
            )
        }
    }

    renderTranslate() {
        let elem = this.props.lang.interface_lang.results;
        return elem.map((item) => {
            // || item.is_active == false
            if (item.lang.id == this.props.lang.learning_lang_one.lang.id) {
                return false
            } else {
                return (
                    <div className='row addWordBlock sentences' id={item.id} key={item.lang.id}>
                        <div className="col-md-4">
                            <label>{item.lang.name}</label>
                        </div>
                        {this.editTranslation(item.id)}
                    </div>
                )
            }
        });
    }

    select(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    uploadState() {
        this.setState({
            person: this.props.lang.notofication_detail.person
        })
    }

    renderPeople() {
        return this.props.chat.personsList.results.map((item, i) => {
            return (
                <div className="col-md-6" key={item.id}>
                    <input type="radio" id={'person' + item.id} checked={item.id == this.state.person}
                           onChange={this.select} name="person" value={item.id}/>
                    <label htmlFor={'person' + item.id}>{item.name}</label>
                </div>
            );
        })
    }

    SubmitForm(props) {
        $('.btn.btn-primary').prop("disabled", true);
        let token = localStorage.getItem('id_token_admin');
        let block = $('.addWordBlock.sentences');
        let arr = [];
        let words = [];
        let data;
        let that = this;
        for (let i = 0; i < block.length; i++) {
            let oneBlock = block[i];
            if ($(oneBlock).find('textarea').val() != '') {
                let obj = {
                    phrase: $(oneBlock).find('textarea').val(),
                    blang: parseInt($(oneBlock).attr('id'))
                }
                arr.push(obj)
            } else {
                $(oneBlock).addClass('has-error');
            }
        }
        if ($('#missed_words span.active').length && $('#missed_words span').length) {
            for (let i = 0; i < $('#missed_words span').length; i++) {
                let oneWord = $('#missed_words span')[i]
                let obj = {
                    word: $(oneWord).text(),
                    visibly: $(oneWord).hasClass('active') ? true : false,
                    count: $(oneWord).text().length
                }
                words.push(obj)
            }
            props.sentence_object = JSON.stringify(words);
            props.missed_words = $("#missed_words").html();
        } else {
            $('#missed_words').parent().addClass('has-erorr');
        }
        if ($('#missed_words').val() == null || $('#missed_words').val() == 'defaultValue') {
            $('#missed_words').closest('.col-md-4').addClass('has-error')
        }
        if(props.sentence_number_notification == "select"){
            props.sentence_number_notification = null
        }
        if(props.live_situation == "select"){
            props.live_situation = null
        }
        props.translations = arr;
        props.flang = this.props.params.id;
        if (typeof props.pronunciation != 'string' || typeof props.grammar != 'string') {
            if (typeof props.pronunciation == 'string') {
                delete props.pronunciation
            }
            if (typeof props.grammar == 'string') {
                delete props.grammar
            }
            data = new FormData();
            for (let i = 0; i < Object.keys(props).length; i++) {
                if (props[Object.keys(props)[i]] != undefined) {
                    data.append(Object.keys(props)[i], props[Object.keys(props)[i]]);
                }
            }
        } else {
            data = props;
        }
        if ($('.addSentence').find('.has-error').length > 0) {
            return false
        } else {
            if ($('input[name="person"]:checked').length > 0) {
                if ($('div#comment').find('.idetBlock').html() != '' && $('div#comment').find('.idetBlock').html() != '<p><br></p>') {
                    let obj = {
                        person: $('input[name="person"]:checked').val(),
                        message: $('div#comment').find('.idetBlock').html()
                    };
                    if (this.props.lang.sentense_detail.notification == null) {
                        this.props.addNotification(token, obj).then((response) => {
                            if (typeof props.pronunciation != 'string' || typeof props.grammar != 'string') {
                                data.append('notification', response.payload.data.id);
                            } else {
                                data['notification'] = response.payload.data.id;
                            }
                            if (this.props.params.id_sentence) {
                                if (typeof data['pronunciation'] == 'string') {
                                    delete data['pronunciation']
                                }
                                if (typeof data['grammar'] == 'string') {
                                    delete data['grammar']
                                }
                                this.props.updateSentence(token, data, this.props.params.id_sentence).then((response) => {
                                    if (response.payload.status == 200) {
                                        let translations = arr;
                                        for (let i = 0; i < translations.length; i++) {
                                            let one = translations[i];
                                            let item = _.findWhere(response.payload.data.translations, {blang: one.blang});
                                            if (_.findWhere(response.payload.data.translations, {blang: one.blang})) {
                                                this.props.updateTranslationSentense(token, one, item.id);
                                            } else {
                                                this.props.addTranslationSentense(token, one, response.payload.data.id);
                                            }
                                        }
                                        this.context.router.push('/language/learning/edit/' + this.props.params.id + '/sentence');
                                    }
                                });
                            } else {
                                this.props.addSentence(token, data).then((response) => {
                                    if (response.payload.status == 201) {
                                        let translations = arr;
                                        for (let i = 0; i < translations.length; i++) {
                                            let one = translations[i];
                                            this.props.addTranslationSentense(token, one, response.payload.data.id);
                                        }
                                        this.context.router.push('/language/learning/edit/' + this.props.params.id + '/sentence');
                                        // this.props.addTranslationSentense(token, translations, response.payload.data.id).then((response)=>{
                                        //     if(response.payload.status == 201){
                                        //         this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence');
                                        //     }
                                        // });
                                    }
                                })
                            }
                        });
                    } else {
                        this.props.updateNotification(token, obj, this.props.lang.sentense_detail.notification).then((response) => {
                            if (typeof props.pronunciation != 'string' || typeof props.grammar != 'string') {
                                data.append('notification', response.payload.data.id);
                            } else {
                                data['notification'] = response.payload.data.id;
                            }
                            if (typeof data['pronunciation'] == 'string') {
                                delete data['pronunciation']
                            }
                            if (typeof data['grammar'] == 'string') {
                                delete data['grammar']
                            }
                            this.props.updateSentence(token, data, this.props.params.id_sentence).then((response) => {
                                if (response.payload.status == 200) {
                                    console.log(next);
                                    let translations = arr;
                                    for (let i = 0; i < translations.length; i++) {
                                        let one = translations[i];
                                        let item = _.findWhere(response.payload.data.translations, {blang: one.blang});
                                        if (_.findWhere(response.payload.data.translations, {blang: one.blang})) {
                                            this.props.updateTranslationSentense(token, one, item.id);
                                        } else {
                                            this.props.addTranslationSentense(token, one, response.payload.data.id);
                                        }
                                    }
                                    if ( !next ){
                                        this.context.router.push('/language/learning/edit/' + this.props.params.id + '/sentence');
                                    } else{
                                        next = false;
                                        this.getNext();
                                    }
                                }
                            });
                        });
                    }
                } else {
                    $('div#comment').find('.idetBlock').parent().addClass('has-error');
                }
            } else {
                if (this.props.params.id_sentence) {
                    if (typeof data['pronunciation'] == 'string') {
                        delete data['pronunciation']
                    }
                    if (typeof data['grammar'] == 'string') {
                        delete data['grammar']
                    }
                    this.props.updateSentence(token, data, this.props.params.id_sentence).then((response) => {
                        if (response.payload.status == 200) {
                            console.log(next);
                            let translations = arr;
                            for (let i = 0; i < translations.length; i++) {
                                let one = translations[i];
                                let item = _.findWhere(response.payload.data.translations, {blang: one.blang});
                                if (_.findWhere(response.payload.data.translations, {blang: one.blang})) {
                                    this.props.updateTranslationSentense(token, one, item.id);
                                } else {
                                    this.props.addTranslationSentense(token, one, response.payload.data.id);
                                }
                            }
                            if ( !next ){
                                this.context.router.push('/language/learning/edit/' + this.props.params.id + '/sentence');
                            } else{
                                next = false;
                                this.getNext();
                            }
                        }
                    });
                } else {
                    this.props.addSentence(token, data).then((response) => {
                        if (response.payload.status == 201) {
                            let translations = arr;
                            for (let i = 0; i < translations.length; i++) {
                                let one = translations[i];
                                this.props.addTranslationSentense(token, one, response.payload.data.id);
                            }
                            this.context.router.push('/language/learning/edit/' + this.props.params.id + '/sentence');
                            // this.props.addTranslationSentense(token, translations, response.payload.data.id).then((response)=>{
                            //     if(response.payload.status == 201){
                            //         this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence');
                            //     }
                            // });
                        }
                    })
                }

            }
        }
        setTimeout(() => {
            $('.btn.btn-primary').prop("disabled", false);
        }, 1000);
    }

    positionValidate(e) {
        let max = parseInt($('input[name="' + e.target.name + '"]').attr('max'));
        // let min = parseInt($('input[name="'+e.target.name+'"]').attr('min'));
        if (e.target.value > max) {
            this.props.fields[e.target.name].onChange(max);
            // }
            // else if (e.target.value < min){
            //     this.props.fields[e.target.name].onChange(min);
        } else {
            this.props.fields[e.target.name].onChange(e.target.value);
        }
    }

    renderSelect=(element, arr)=> {
        setTimeout(()=>{
            if(this.props.lang[arr].length > 0){
                this.props.lang[arr].forEach((item, index) => {
                    if ($('#'+element).find('option#' + index).length == 0) {
                        if(element == 'sentence_number_notification'){
                            $('#'+element).append($('<option>', {
                                value: item.id,
                                text: item.title,
                                id: index
                            }));
                        }else{
                            $('#'+element).append($('<option>', {
                                value: item.id,
                                text: item.number+' '+item.title,
                                id: index
                            }));
                        }
                    }
                });
            }
            $('#'+element).selectpicker();
            $('#'+element).selectpicker('refresh');
            if(this.props.lang.sentence_detail && this.props.lang.sentence_detail.live_situation){
                setTimeout(()=>{
                    this.props.fields.live_situation.onChange(this.props.lang.sentence_detail.live_situation)
                }, 100)
            }
            if(this.props.lang.sentence_detail && this.props.lang.sentence_detail.sentence_number_notification){
                setTimeout(()=>{
                    this.props.fields.sentence_number_notification.onChange(this.props.lang.sentence_detail.sentence_number_notification)
                }, 100)
            }
        }, 100)

        // this.props.fields.live_situation.onChange('3')
    }
    changeSelect=(e)=>{
        this.props.fields[e.target.name].onChange(e.target.value)
    };
    toDoNext=(id, page)=>{
        this.props.lang.sentense_detail = {};
        this.props.lang.notofication_detail = {};
        this.props.lang.sentense = {};
        this.props.resetForm();
        this.setState({
            person: false
        });
        
        this.setState({
            pronunciation: null,
            grammar: null
        });
        $('input').val('');

        let token = localStorage.getItem('id_token_admin');
        this.props.GetOneLearningLanguage(this.props.params.id, token);
        this.props.GetInterfaceLang(token);
        this.props.GetChatPerson(token);
        this.props.PaginationSentence(token, page, this.props.params.id);
        this.props.getSituationSelect(token, this.props.params.id, id);
        this.props.getNotificationSelect(token, this.props.params.id, id);

        if (this.props.params.id_before) {
            position_sentence = this.props.params.id_before;
        } else {
            position_sentence = '';
        }
        if (id) {
            this.props.getDetailSentense(id, token, this.props.params.id).then((response) => {
                if (response.payload.data.notification) {
                    this.props.getNotification(token, response.payload.data.notification)
                }
            });
        }
        if (id) {
            this.setState({
                sentence: true
            })
        }
        this.context.router.push("/language/learning/edit/"+this.props.params.id+"/sentence/edit/"+id+"/")
    };
    formDb=()=>{
        next = true;
        $('.click__sb').click();
    };
    getNext=()=>{
        let id;
        let index = '';
        let next = this.props.lang.sentense.next;
        let page = next && next.split('page=')[1]-1 != 0 ? next.split('page=')[1]-1 : 1;
        let id_sentence = this.props.params.id_sentence;
        let arr = this.props.lang.sentense.results;
        let token = localStorage.getItem('id_token_admin');

        if (!arr || !arr.length) return false;
        arr.forEach((el, i)=>{
            if (el.id == id_sentence) {
                index = i
            }
        });
        if(index+1 == arr.length && next == null){
            return false
        }else if (index+1 == arr.length && next != null){
            let page_ = next ? next.split('page=')[1] : 1;
            this.props.PaginationSentence(token, page_, this.props.params.id).then((res)=>{
                if(res.payload.status == 200 || res.payload.status == 201){
                    setTimeout(()=>{
                        this.toDoNext(this.props.lang.sentense.results[0].id, page_)
                    }, 200)
                }
            })
        }else if(index+1 == arr.length && next == null){

        }else{
            id = arr[index+1].id;
            this.toDoNext(id, page);
        }
    };
    render() {
        const { fields: {
            change_position,
            study_type,
            phrase,
            translations,
            time_to_speak,
            commentary,
            grammar,
            sentence_object,
            live_situation,
            hint,
            pronunciation,
            sentence_number_notification,
            missed_words}, handleSubmit} = this.props;
        if(this.state.person == false && this.props.lang.notofication_detail.person){
            this.uploadState()
        }
        return (
            <div className="dashboard-wrapper">
                <p className="dashboard-title">{this.props.params.id_sentence ? "Edit Sentence" : "Add Sentence"}</p>
                <p className="dashboard-text">{this.props.lang.learning_lang_one.lang ? this.props.lang.learning_lang_one.lang.name : "" }</p>
                <form className="addSentence" onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="study_type">Select function</label>
                                </div>
                                <div className='col-md-4'>
                                    <select className="selectpicker" name="study_type" id="study_type" disabled={study_type.initialValue != 'select' ? 'disabled' : ''}  {...study_type} data-live-search="true" onChange={this.chooseFunc}>
                                        <option value="select">Select function</option>
                                        <option value="1">Memorise</option>
                                        <option value="2">Writing</option>
                                        <option value="3">Speaking</option>
                                    </select>
                                </div>
                            </div>
                            {this.state.study_type != 'select' || study_type.initialValue != 'select' ?
                                <div className='clearfix'>
                                    <div className="col-md-4">
                                        <label htmlFor="change_position">Position #</label>
                                    </div>
                                    <div className='col-md-4'>
                                        <input type="number"
                                               max={this.props.lang.sentense.count}
                                               name="change_position"
                                               className="form-control"
                                               id="change_position"
                                               placeholder=""
                                               {...change_position}
                                               onChange={this.positionValidate}
                                        />
                                    </div>
                                </div>
                                :
                                ""
                            }
                        </div>
                        {this.state.study_type != 'select' || study_type.initialValue != 'select' ?
                            <div className="white-block block-4-8 clearfix">
                                {this.state.study_type != 'select' || study_type.initialValue != 'select' ?
                                    <div>
                                        <div className='clearfix'>
                                            <div className="col-md-4">
                                                <label htmlFor="phrase">Sentence in the foreign language</label>
                                            </div>
                                            <div className={ phrase.touched && !phrase.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                    <textarea className="form-control"
                                              name="phrase"
                                              id="phrase"
                                              {...phrase}
                                              onChange={this.addWordSelect}
                                    />
                                            </div>
                                        </div>
                                        <div className='clearfix'>
                                            <div className="col-md-4">
                                                <label>Pronunciation file</label>
                                            </div>

                                            <div className='col-md-2'>
                                                <label htmlFor="pronunciation" className="btn btn-primary pull-left">Choose file</label>
                                            </div>
                                            <div className={pronunciation.touched && !pronunciation.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                                <input type="file"
                                                       style={{display: 'none'}}
                                                       name="pronunciation"
                                                       id="pronunciation"
                                                       onChange={this.handleChange}
                                                />
                                                <input type="text"
                                                       placeholder={pronunciation.initialValue ? pronunciation.initialValue :"File"}
                                                       className="form-control"
                                                       name="pronunciation2"
                                                       id="pronunciation2"
                                                       disabled
                                                       value = {this.state.pronunciation}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    ""
                                }
                                {this.state.study_type == '3' || study_type.initialValue == '3' ?
                                    <div className="border-top-sentence">
                                        <div className="clearfix addWordBlock missed_words_block" id="hint">
                                            <div className="col-md-4">
                                                <label>Hint</label>
                                            </div>
                                            <div className={hint.touched && !hint.valid  ? 'col-md-4 has-error' : 'col-md-4'}>
                                                <div dangerouslySetInnerHTML={{__html: hint.initialValue}} style={{cursor: 'pointer'}} name="hint" id="hint_block"></div>
                                            </div>
                                        </div>
                                        <div className="clearfix addWordBlock without-border" id="time_to_speak">
                                            <div className="col-md-4">
                                                <label>Timer <span>(seconds)</span></label>
                                            </div>
                                            <div className={time_to_speak.touched && !time_to_speak.valid  ? 'col-md-4 has-error' : 'col-md-4'}>
                                                <input type="number"
                                                       name="time_to_speak"
                                                       className="form-control"
                                                       id="time_to_speak"
                                                       placeholder="Seconds"
                                                       {...time_to_speak}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    :""}
                                {this.state.study_type != 'select' || study_type.initialValue != 'select' ?
                                    <div className="clearfix blockTranslate border-bottom-none">
                                        <p className="title">Translate</p>
                                        {this.props.lang.interface_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.sentense_detail ?
                                            <div className="col-md-12">
                                                {this.renderTranslate()}
                                            </div>
                                            : ""
                                        }
                                    </div>
                                    :""}
                                {this.state.study_type == '1' || study_type.initialValue == '1' ?
                                    <div className="clearfix only-top-border" style={{'marginBottom': '10px'}}>
                                        <div className="col-md-12">
                                            <div className="row addWordBlock missed_words_block" >
                                                <div className='clearfix'>
                                                    <div className="col-md-4">
                                                        <label htmlFor="missed_words">Word selection</label>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div dangerouslySetInnerHTML={{__html: missed_words.initialValue}} style={{cursor: 'pointer'}} name="missed_words" id="missed_words"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :""}
                                {this.state.study_type == '1' || study_type.initialValue == '1' ?
                                    <div className="clearfix only-top-border">
                                        <div className="col-md-12">
                                            <div className="row addWordBlock missed_words_block" >
                                                <div className='clearfix'>
                                                    <div className="col-md-4">
                                                        <label htmlFor="live_situation">Choose live-situations</label>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <select className="selectpicker" id="live_situation" name="live_situation" {...live_situation} data-live-search="true" onChange={this.changeSelect}>
                                                            <option value="select">Select live-situations</option>
                                                            {this.props.lang.situation_select && this.renderSelect('live_situation', 'situation_select')}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :""}
                                {/*{this.state.study_type == '1' || study_type.initialValue == '1' ?*/}
                                {/*<div className="clearfix only-top-border" style={{'marginTop' : '20px'}}>*/}
                                {/*<div className="col-md-12">*/}
                                {/*<div className="row addWordBlock missed_words_block" >*/}
                                {/*<div className='clearfix'>*/}
                                {/*<div className="col-md-4">*/}
                                {/*<label htmlFor="sentence_number_notification">Choose notification</label>*/}
                                {/*</div>*/}
                                {/*<div className='col-md-4'>*/}
                                {/*<select className="selectpicker" id="sentence_number_notification" name="sentence_number_notification" {...sentence_number_notification} data-live-search="true" onChange={this.changeSelect}>*/}
                                {/*<option value="select">Select notification</option>*/}
                                {/*{this.props.lang.notification_select && this.renderSelect('sentence_number_notification', 'notification_select')}*/}
                                {/*</select>*/}
                                {/*</div>*/}
                                {/*</div>*/}
                                {/*</div>*/}
                                {/*</div>*/}
                                {/*</div>*/}
                                {/*:""}*/}
                                {this.state.study_type == '1' || study_type.initialValue == '1' ?
                                    <div className="clearfix blockTranslate" style={{'borderBottom': 'none'}}>
                                        <p className="title">Grammar Box</p>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Choose image</label>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="grammar" className="btn btn-primary pull-left">Choose file</label>
                                                </div>
                                                <div className='col-md-2'>
                                                    <input type="file"
                                                           style={{display: 'none'}}
                                                           name="grammar"
                                                           id="grammar"
                                                           onChange={this.handleChange}
                                                    />
                                                    <input type="text"
                                                           placeholder={grammar.initialValue ? grammar.initialValue :"File"}
                                                           className="form-control"
                                                           name="grammar2"
                                                           id="grammar2"
                                                           disabled
                                                           initialValue="yes"
                                                           value = {this.state.grammar}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :""}
                                {this.state.study_type == '1' || this.state.study_type == '2' || study_type.initialValue == '1' || study_type.initialValue == '2' ?
                                    <div className="clearfix addWordBlock without-border" style={{'borderTop': '2px dotted #ccc'}}>
                                        <p className="title">Commentary Box</p>
                                        <div className="col-md-12" id="commentaryBox">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Comment</label>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className="idetBlock" dangerouslySetInnerHTML={{__html: commentary.initialValue}}></div>
                                                    <div className="blockBtn">
                                                        <button id="edit" data-name="commentary" data-id="commentaryBox" className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                                        <button id="save" data-name="commentary" data-id="commentaryBox" className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :""}
                                {(this.state.study_type != 'select' && this.state.study_type != '3') || (study_type.initialValue != 'select' && study_type.initialValue != '3') ?
                                    <div className="clearfix blockTranslate chat_box_only">
                                        <p className="title">Chat Box</p>
                                        <div className="col-md-12 personBlock">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Select Person</label>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="row">
                                                        {this.props.chat.personsList.results && this.props.lang.notofication_detail ? this.renderPeople() : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clearfix addWordBlock without-border" id="comment">
                                            <div className="col-md-4">
                                                <label>Comment</label>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="idetBlock" dangerouslySetInnerHTML={{__html: this.props.lang.notofication_detail.message}}></div>
                                                <div className="blockBtn">
                                                    <button id="edit" data-name="notification" data-id="comment" className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                                    <button id="save" data-name="notification" data-id="comment" className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :""}
                            </div>
                            :""}
                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                <Link to={"/language/learning/edit/"+this.props.params.id+"/sentence/"} className="btn btn-default">Cancel</Link>
                                {this.state.study_type != 'select' || study_type.initialValue != 'select' ? <button type="submit" className="btn btn-primary click__sb">Save</button> : ""}
                                <span onClick={()=>{this.formDb()}} className="btn btn-default">Next</span>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="clearfix"></div>
            </div>
        );
    }
}

function validate(values) {
    const errors = {};
    if($('#time_to_speak').length > 0){
        if(!values.time_to_speak){
            errors.time_to_speak = 'Enter a title'
        }
    }
    if($('#hint').length > 0){
        if(!values.hint){
            errors.hint = 'Enter a title'
        }
    }
    // if($('#commentaryBox').length > 0){
    //     if(!values.commentary){
    //         errors.commentary = 'Enter a title'
    //     }
    // }
    if(!values.phrase){
        errors.phrase = 'Enter a phrase'
    }
    if(!values.pronunciation){
        errors.pronunciation = 'Enter a phrase'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        lang: state.lang,
        chat: state.chat,
        initialValues:{
            notification: null,
            study_type: state.lang.sentense_detail.study_type || 'select',
            phrase: state.lang.sentense_detail.phrase || '',
            commentary: state.lang.sentense_detail.commentary || '',
            grammar: state.lang.sentense_detail.grammar || '',
            pronunciation: state.lang.sentense_detail.pronunciation || '',
            hint: state.lang.sentense_detail.hint || '',
            time_to_speak: state.lang.sentense_detail.time_to_speak || null,
            missed_words : state.lang.sentense_detail.missed_words || '',
            persons: state.lang.notofication_detail.person || '',
            live_situation: state.lang.sentense_detail.live_situation || '',
            sentence_number_notification: state.lang.sentense_detail.sentence_number_notification || '',
            change_position:  state.lang.sentense_detail.position || position_sentence
        }
    }
}
export default reduxForm({
    form: 'Add Sentence',
    enableReinitialize : true,
    fields: ['id_before', 'phrase', 'translations', 'change_position', 'id_after', 'live_situation', 'sentence_number_notification', 'sentence_object', 'id_before', 'study_type', 'hint', 'missed_words', 'grammar', 'commentary', 'pronunciation', 'time_to_speak', 'position', 'flang', 'vocabilary_word', 'notification'],
    validate
}, mapStateToProps, {PaginationSentence ,GetInterfaceLang, GetOneLanguage, getSentence, getSituationSelect, getNotificationSelect, GetOneLearningLanguage, getDetailSentense, GetChatPerson, addSentence, addNotification, getNotification, addTranslationSentense, updateNotification, updateSentence, updateTranslationSentense})(AddWord);

// {commentary.touched && !commentary.valid  ? 'col-md-4 has-error' : 'col-md-4'}
// if($('.addSentence').find('.has-error').length > 0){return false}else{
//             if($('input[name="person"]:checked').length > 0){
//                 if($('div#comment').find('.idetBlock').html() != '' && $('div#comment').find('.idetBlock').html() != '<p><br></p>'){
//                     let obj={
//                         person: $('input[name="person"]:checked').val(),
//                         message: $('div#comment').find('.idetBlock').html()
//                     };
//                     if(this.props.lang.sentense_detail.notification == null){
//                         this.props.addNotification(token, obj).then((response)=>{
//                             if(props.grammar || props.pronunciation){data.append('notification', response.payload.data.id);
//                             }else{data['notification'] = response.payload.data.id;}
//                             this.props.addSentence(token, data).then((response)=>{
//                                 if(response.payload.status == 201){
//                                     let translations = arr;
//                                     if(response.payload.data.study_type == 2 || response.payload.data.study_type == 3){
//                                         this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence');
//                                     }else{
//                                         this.props.addTranslationSentense(token, translations, response.payload.data.id).then((response)=>{
//                                             if(response.payload.status == 201){
//                                                 this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence');
//                                             }
//                                         });
//                                     }
//
//                                 }
//                             })
//                         })
//                     }else{
//                         this.props.updateNotification(token, obj, this.props.lang.sentense_detail.notification);
//                     }
//                 }else{
//                     $('div#comment').find('.idetBlock').parent().addClass('has-error');
//                 }
//                 // let obj={
//                 //
//                 // }
//             }else{
//                 this.props.addSentence(token, data).then((response)=>{
//                     if(response.payload.status == 201){
//                         let translations = arr;
//                         if(response.payload.data.study_type == 2 || response.payload.data.study_type == 3){
//                             this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence');
//                         }else{
//                             this.props.addTranslationSentense(token, translations, response.payload.data.id).then((response)=>{
//                                 if(response.payload.status == 201){
//                                     this.context.router.push('/language/learning/edit/'+this.props.params.id+'/sentence');
//                                 }
//                             });
//                         }
//
//                     }
//                 })
//             }
//         }
// <select className="selectpicker" name="missed_words" id="missed_words" defaultValue={missed_words.value || 'defaultValue'} placeholder={missed_words.value} data-live-search="true" onChange={this.chooseFunc}>
//                                                             <option value="defaultValue" disabled="disabled">Select</option>
//                                                         </select>

//132
// this.sspanate({
//     [e.target.name]: e.target.value
// });
// this.props.fields[e.target.name].onChange(e.target.value);
// let arrSelect = [];
// let string = e.target.value;
// let arr = string.split(' ');
// for(let i=0; i<$('#missed_words option').length; i++){
//     let one = $('#missed_words option')[i];
//     arrSelect.push($(one).val())
// }
// arr.forEach((word)=>{
//     if(arrSelect.indexOf(word) != -1 || word == ''){
//         return false
//     }else{
//         $('#missed_words').append($('<option>', {
//             value: word,
//             text : word,
//             id : word
//         }));
//     }
// });
// arrSelect.forEach((elem)=>{
//     if(arr.indexOf(elem) == -1 && elem != 'defaultValue'){
//         $("#missed_words option[value='"+elem+"']").remove();
//     }else{
//         return false
//     }
// });
// $('.selectpicker').selectpicker('refresh')

//<div className="idetBlock" dangerouslySetInnerHTML={{__html: hint.initialValue}}></div> <div className="blockBtn"> <button id="edit" data-name="hint" data-id="hint" className="btn btn-default" onClick={this.edit} type="button">Edit</button> <button id="save" data-name="hint" data-id="hint" className="btn btn-primary" onClick={this.save} type="button">Save</button> </div>


// WEBPACK FOOTER //
// ./src/components/language/addSentence.js